import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import GetStarted from './pages/GetStarted';
import Admin from './pages/Admin';
import CountdownBar from './components/CountdownBar';
import { Toaster } from './components/ui/toaster';

const TopBarGate = () => {
  const location = useLocation();

  if (location.pathname.startsWith('/admin')) return null;

  return <CountdownBar />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <TopBarGate />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/get-started" element={<GetStarted />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>

        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
